<!-- removeItemModal -->
<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="w-100 phone-selection" data-popper-placement="bottom-start">
        <div class="py-3 pt-1 searchlist-input">
          <input
            type="text"
            class="form-control border search-countryList"
            placeholder="{{ 'label-title.search-country-name-or-country-code' | translate }}"
            [(ngModel)]="searchText"
          />
        </div>
        <ul class="list-unstyled dropdown-menu-list mb-0">
          @for(country of countryArray | filter: searchText ; track $index){
          <li class="dropdown-item d-flex">
            <div class="flex-grow-1">
              @if (country.phoneCodes.length == 1) {
              <div class="row">
                <div class="col-12">
                  <div class="country-name me-1 c-pointer px-2 py-2" (click)="countrySelect(country.phoneCodes[0], country.code2)">
                    {{ country.name }} ({{ country.phoneCodes }})
                  </div>
                </div>
              </div>
              } @else{
              <div class="live-preview flush_accordion">
                <div ngbAccordion activeIds="static-1" class="accordion-flush" [closeOthers]="true">
                  <div ngbAccordionItem id="static-1" [collapsed]="true">
                    <div ngbAccordionHeader class="accordion-header border-0 bg-transparent">
                      <button ngbAccordionButton>{{ country.name }}</button>
                    </div>
                    <div ngbAccordionCollapse>
                      @for(code of country.phoneCodes; track $index){
                      <div ngbAccordionBody>
                        <ng-template>
                          <div class="row">
                            <div class="col-12 c-pointer" (click)="countrySelect(code, country.code2)">{{ country.name }} ({{ code }})</div>
                          </div>
                        </ng-template>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
</ng-template>
